import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { toast } from '../Toast';

export default function CancelAddonModal({ isOpen, onClose, addon, cancelAt, onConfirm }) {
  const [processing, setProcessing] = useState(false);
  const { t } = useTranslation('billing');
  const { t: tc } = useTranslation('common');

  if (!isOpen || !addon) return null;

  const handleConfirm = async () => {
    setProcessing(true);
    try {
      await onConfirm(addon.id);
      onClose();
    } catch (error) {
      console.error('Error cancelling addon:', error);
      toast.error(t('cancelModal.error'));
    } finally {
      setProcessing(false);
    }
  };

  const formattedDate = cancelAt
    ? new Date(cancelAt).toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' })
    : t('cancelModal.endOfPeriod');

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content cancel-addon-modal" onClick={e => e.stopPropagation()}>
        <h3>{t('cancelModal.title')}</h3>
        <p dangerouslySetInnerHTML={{ __html: t('cancelModal.message', { name: addon.name, date: formattedDate }) }} />
        <div className="modal-actions">
          <button
            className="btn-cancel-confirm"
            onClick={handleConfirm}
            disabled={processing}
          >
            {processing ? tc('processing') : t('cancelModal.confirm')}
          </button>
          <button className="btn-cancel-back" onClick={onClose} disabled={processing}>
            {t('cancelModal.back')}
          </button>
        </div>
      </div>
    </div>
  );
}
